export const WDS_ATTRACTIONS_LOCATIONS = {
  'Spider-Man W.E.B. Adventure': {
    longitude: 2.779369354248047,
    latitude: 48.86611484299536
  },
  'Avengers Assemble: Flight Force': {
    longitude: 2.7794149518013,
    latitude: 48.86544789048844
  },
  'Slinky® Dog Zigzag Spin': {
    longitude: 2.776959,
    latitude: 48.867136
  },
  'Cars Quatre Roues Rallye': {
    longitude: 2.777854,
    latitude: 48.867726
  },
  'Cars ROAD TRIP': {
    longitude: 2.775024175643921,
    latitude: 48.86651889190989
  },
  'Entry to World of Frozen': {
    longitude: 2.776453,
    latitude: 48.86495
  },
  'Raiponce Tangled Spin': {
    longitude: 2.77663,
    latitude: 48.866153
  },
  'Frozen Ever After': {
    longitude: 2.773508,
    latitude: 48.864108
  },
  'Crush\'s Coaster': {
    longitude: 2.778142,
    latitude: 48.868041
  },
  'Les Tapis Volants - Flying Carpets Over Agrabah®': {
    longitude: 2.778352,
    latitude: 48.868288
  },
  'Ratatouille : L\'Aventure Totalement Toquée de Rémy​': {
    longitude: 2.7762224525213237,
    latitude: 48.86757046243673
  },
  'RC Racer': {
    longitude: 2.776651,
    latitude: 48.866903
  },
  'The Twilight Zone Tower of Terror': {
    longitude: 2.778767,
    latitude: 48.866753
  },
  'Toy Soldiers Parachute Drop': {
    longitude: 2.777234,
    latitude: 48.867188
  },
  'Animation Academy': {
    longitude: 2.7783317864486885,
    latitude: 48.86742740189942
  }
}; 